module.exports = __webpack_public_path__ + "static/media/payyoudes.681dc155.png";